/**
 * MVMNT Size Chart Component
 * Following Shopify Extension Pattern
 *
 * Usage: Place this in assets/ and include in theme.liquid with:
 * <script src="{{ 'custom-size-chart.js' | asset_url }}" defer></script>
 */

class MVMNTSizeChart extends HTMLElement {
  constructor() {
    super();
    this.attachListeners();
  }

  connectedCallback() {
    // Component is added to the DOM
    console.log('MVMNT Size Chart: Component mounted');
  }

  attachListeners() {
    const trigger = this.querySelector('[data-size-chart-trigger]');
    const modal = this.querySelector('[data-size-chart-modal]');
    const closeButton = this.querySelector('[data-size-chart-close]');
    const overlay = this.querySelector('[data-size-chart-overlay]');

    if (!trigger || !modal) {
      console.warn('MVMNT Size Chart: Missing required elements');
      return;
    }

    // Open modal
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      this.openModal();
    });

    // Close modal on button click
    if (closeButton) {
      closeButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.closeModal();
      });
    }

    // Close modal on overlay click
    if (overlay) {
      overlay.addEventListener('click', () => {
        this.closeModal();
      });
    }

    // Close on ESC key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) {
        this.closeModal();
      }
    });
  }

  openModal() {
    const modal = this.querySelector('[data-size-chart-modal]');
    const overlay = this.querySelector('[data-size-chart-overlay]');

    if (modal) {
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');

      // Prevent body scroll
      document.body.style.overflow = 'hidden';

      // Focus first focusable element
      const focusable = modal.querySelector('button, a, [tabindex]:not([tabindex="-1"])');
      if (focusable) {
        focusable.focus();
      }
    }

    if (overlay) {
      overlay.classList.add('is-visible');
    }
  }

  closeModal() {
    const modal = this.querySelector('[data-size-chart-modal]');
    const overlay = this.querySelector('[data-size-chart-overlay]');

    if (modal) {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');

      // Restore body scroll
      document.body.style.overflow = '';
    }

    if (overlay) {
      overlay.classList.remove('is-visible');
    }
  }
}

// Register the custom element
if (customElements && !customElements.get('mvmnt-size-chart')) {
  customElements.define('mvmnt-size-chart', MVMNTSizeChart);
  console.log('MVMNT Size Chart: Component registered successfully');
}
